import DelayedImpressionObserver from './DelayedImpressionObserver';
export default DelayedImpressionObserver;